import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Lib
import {
    MANAGER_NOT_ALLOWED_BY_ADMIN_TO_ADD_SP,
    PROFILE_TRIAL_LIMITATION,
    TIKTOK_ACCOUNT_NO_VIDEO
} from '@/lib/socialProfile';

// Components
import InfoBanner from '@/components/base/InfoBanner';

const ErrorAddSingleProfileBanner = ({
    error = null,
    onClose = () => {
        /** */
    },
    className
}) => {
    const { t } = useTranslation('errors');
    if (!error) {
        return null;
    }

    let title = 'error';
    let message = 'add_social_profiles.unknown_error_add_profile';
    switch (error) {
        case TIKTOK_ACCOUNT_NO_VIDEO:
            title = 'add_social_profiles.tiktok_error_profile_no_video_title';
            message = 'add_social_profiles.tiktok_error_profile_no_video_text';
            break;
        case PROFILE_TRIAL_LIMITATION:
            message = 'add_social_profiles.social_profile_already_in_free_trial';
            break;
        case MANAGER_NOT_ALLOWED_BY_ADMIN_TO_ADD_SP:
            message =
                'commons:list_social_profiles.error_add_social_profile_manager_no_rights_by_admin_single_profile';
            break;
    }

    return (
        <InfoBanner
            type="error"
            className={className}
            title={t(title)}
            message={t(message)}
            onClose={onClose}
        />
    );
};

ErrorAddSingleProfileBanner.propTypes = {
    error: PropTypes.string,
    onClose: PropTypes.func
};

export default ErrorAddSingleProfileBanner;
